import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=326d87bf&scoped=true"
import script from "./RequestForm.vue?vue&type=script&lang=js"
export * from "./RequestForm.vue?vue&type=script&lang=js"
import style0 from "./RequestForm.vue?vue&type=style&index=0&id=326d87bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326d87bf",
  null
  
)

export default component.exports